import {createContext, useState} from 'react';
import { IAuthProvider, IContext, IUser } from './types';
import { LoginRequest, setUserLocalStorage } from './util';

export const AuthContext = createContext<IContext>({} as IContext);

export const AuthProvider = ({ children }: IAuthProvider) => {
  const userInitialState : IUser = {
    username: '',
    accessToken: ''
  }
  const [user, setUser] = useState<IUser>(userInitialState);

  // useEffect(() => {
  //   const user = getUserLocalStorage();

  //   if(user) {
  //     setUser(user);
  //   }
  // }, [])

  async function authenticated(username: string, password: string) {
    const response = await LoginRequest(username, password)

    const payload = {accessToken: response?.accessToken, username }

    setUser(payload);
    setUserLocalStorage(payload);
  }

  function logout() {
    setUser(userInitialState)
    localStorage.clear();
  }

  return (
    <AuthContext.Provider value={{ user, authenticated, logout }}>
      {children}
    </AuthContext.Provider>
  )
}
